<div class="language-switcher">
  <select [value]="currentLanguage" (change)="switchLanguage($event)">
    @for(language of languages;track $index){
    <option [value]="language.short">{{language.name | translate }}</option>
    }
  </select>
</div>